export function isFirefox(): boolean {
	return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('firefox');
}

export function silenceRadixDialogTitleWarning() {
	if (typeof window === 'undefined') return;
	const orig = console.error;
	console.error = (...args) => {
		const msg = args?.[0];
		if (typeof msg === 'string' && msg.includes('DialogContent') && msg.includes('DialogTitle'))
			return;
		orig(...args);
	};
}
